import { LANGUAGE } from '../enums/language.enum';

export const LANGUAGE_LIST = [
  { id: LANGUAGE.EN, displayValue: 'English' },
  { id: LANGUAGE.FR, displayValue: 'French' },
  { id: LANGUAGE.DE, displayValue: 'German' },
  { id: LANGUAGE.IT, displayValue: 'Italian' },
];
